// extracted by mini-css-extract-plugin
module.exports = {"text":"style_text__r1YSr"};